// extracted by mini-css-extract-plugin
module.exports = {"root":"TabNav_root__2TBZH","tab":"TabNav_tab__2IyX1","link":"TabNav_link__Ehr4N","selectedLink":"TabNav_selectedLink__3adlL","disabled":"TabNav_disabled__2A5za"};